<template>
<!--  <button-->
<!--      :type="type"-->
<!--      :class="btnClasses"-->
<!--  >-->
<!--    {{ btnText }}-->
<!--  </button>-->
<!-- ms-auto -->
  <a class="btn btn-icon btn-bg-light small" style="min-height: 0;" :class="{'delete': action == 'delete'}">
    <!--begin::Svg Icon | path: icons/duotune/art/art005.svg-->
    <span class="">
      <component :is="btnIcon"/>
    </span>
    <!--end::Svg Icon-->
  </a>
</template>

<script>
import IconEdit from '../../svg/EditPencilIcon.vue'
import IconDelete from '../../svg/DeleteIcon.vue'

const actions = ['edit', 'delete']
export default {
  components: {IconEdit, IconDelete},
  props: {
    type: {
      default: 'button'
    },
    action: {
      default: 'edit'
    },
    classes: {
      default: ''
    },
    text: {
      default: '',
    }
  },
  computed: {
    btnText() {
      if (this.text) return this.text;

      let text_ = ''
      switch (this.action) {
        case 'edit':
          text_ = this.$t("edit")
          break
        case 'delete':
          text_ = this.$t("delete")
          break
        case 'filter':
          text_ = this.$t("filter")
          break
      }

      return text_
    },
    btnClasses() {
      if (this.classes) return this.classes;

      let classes_ = 'btn btn-sm '
      switch (this.action) {
        case 'edit':
          classes_ += 'btn-primary '
          break
        case 'delete':
          classes_ += 'btn-danger '
          break
        case 'filter':
          classes_ += 'btn-primary '
          break
      }

      return classes_
    },
    btnIcon() {
      // if (this.classes) return this.classes;

      let classes_ = IconEdit
      switch (this.action) {
        case 'edit':
          classes_ = IconEdit
          break
        case 'delete':
          classes_ = IconDelete
          break
        case 'filter':
          classes_ = IconEdit
          break
      }

      return classes_
    }
  }
}
</script>